import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: '',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      type: 'Sprite',
      name: 'RewardContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_fee_reward_frame',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: 'e9a58b28-a385-4d56-add2-cd3c5c7c3bc9',
      type: 'Sprite',
      name: 'RewardCheckHolder',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_reward_shadow',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: '716fda09-edea-4311-b975-8cf56037db65',
      type: 'NineSlicePlane',
      name: 'RewardTooltip',
      nameSpace: '',
      className: '',
      x: -34,
      y: -70,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 100,
      leftWidth: 30,
      topHeight: 0,
      rightWidth: 30,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_bubble',
      parent: 'ca816ee2-2612-4e37-be37-74c40d43de14',
      data: ''
    },
    {
      id: 'f62988a0-ceb7-4c7d-a06a-c25d0a76d139',
      type: 'Sprite',
      name: 'RewardIcon',
      nameSpace: '',
      className: '',
      x: 65,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gas_can_reward',
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    },
    {
      id: '049996ce-75ae-4531-a95f-8ae1df34016f',
      type: 'Text',
      name: 'RewardText',
      nameSpace: '',
      className: '',
      x: 65,
      y: 90,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    },
    {
      id: '8f5503aa-022c-45b0-a7d6-2ff98b6282e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 91,
      y: 91,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_check',
      parent: 'e9a58b28-a385-4d56-add2-cd3c5c7c3bc9',
      data: ''
    },
    {
      id: '72b4ce7a-8358-4ad8-b602-8b0d33e9c36b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 72,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_tooltip_tail',
      parent: '716fda09-edea-4311-b975-8cf56037db65',
      data: ''
    },
    {
      id: '86168e5b-6c23-4f07-b3ac-18aac60a6105',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 100,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassTooltipLocked',
      localize: true,
      maxWidth: 170,
      maxHeight: 68,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8d3321',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 170,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '716fda09-edea-4311-b975-8cf56037db65',
      data: ''
    },
    {
      id: '59ee2a92-3d10-415b-92e1-5b45cce4deb3',
      type: 'Container',
      name: 'RewardGlowContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'da9c5f4d-9f68-4f25-89e5-3a0748a11718',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class SeasonPassRewardFree {
  static raw = raw;
  root: PIXI.Container
  RewardContainer: PIXI.Sprite
  RewardGlowContainer: PIXI.Container
  RewardIcon: PIXI.Sprite
  RewardText: PIXI.Text
  RewardCheckHolder: PIXI.Sprite
  RewardTooltip: PIXI.NineSlicePlane

  constructor() {
    populate(this, raw);
  }
}
